import React from "react";
import { MainWrapper, Wrapper, Box, InvisibleBox, InsideBox, Header, Span, HeaderWrapper, Title,
Container, MainHeaderContainer, HelpContainer, HelpIcon, HelpTooltip, CustomHelpIcon } from "./styles";
import Spinner from "../../components/Spinner/Spinner";
import { DoughnutChart } from "../../components/DoughnutChart";
import { LineChart } from "../../components/LineChart";
import { BarChart } from "../../components/BarChart";
import { getAdminStatistics, downloadStatistics } from "../../services/statistics/getStatistics";
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import BookmarkRemoveIcon from '@mui/icons-material/BookmarkRemove';
import theme from "../../theme/theme";
import { Divider, Button, CircularProgress } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';

const AdminStatistics = () => {
    // ------------------- JWT -------------------
    const jwt = localStorage.getItem('jwt');


    // ------------------- STATES -------------------
    const [loadingStatistics, setLoadingStatistics] = React.useState(false);
    const [downloadingStatistics, setDownloadingStatistics] = React.useState(false);
    const [statistics, setStatistics] = React.useState<any>(null);

    const [uncompletedLabels, setUncompletedLabels] = React.useState<any>([]);
    const [uncompletedData, setUncompletedData] = React.useState<any>([]);

    const [completedLabels, setCompletedLabels] = React.useState<any>([]);
    const [completedData, setCompletedData] = React.useState<any>([]);

    const [dateLabels, setDateLabels] = React.useState<any>([]);
    const [dateData, setDateData] = React.useState<any>([]);

    // ------------------- USE EFFECT -------------------
    React.useEffect(() => {
        getStatistics();
    }, []);
    
    React.useEffect(() => {
    }, [downloadingStatistics]);

    React.useEffect(() => {
        if (statistics) {
            const uncompletedReservations = statistics.resources_uncompleted_reservations;
            setUncompletedLabels(Object.keys(uncompletedReservations));
            setUncompletedData(Object.values(uncompletedReservations));

            const completedReservations = statistics.resources_completed_reservations;
            setCompletedLabels(Object.keys(completedReservations));
            setCompletedData(Object.values(completedReservations));

            const reservationsInTime = statistics.dates_dict;
            setDateLabels(Object.keys(reservationsInTime));
            setDateData(Object.values(reservationsInTime));
        }
    }, [statistics]);


    // ------------------- GET INFO FROM API -------------------
    const getStatistics = async () => {
        setLoadingStatistics(true);
        await getAdminStatistics(jwt!)
            .then((res) => {
                if (res && res.data && res.status < 300) {
                    setStatistics(res.data);
                }
            })
            .catch((err) => {
                console.log(err, "err");
            });

        setLoadingStatistics(false);
    };

    const dlStatistics = async () => {
        setDownloadingStatistics(true);
        await downloadStatistics(jwt!)
            .then((res) => {
                if (res && res.data) {
                    // setStatistics(res.data);
                }
            })
            .catch((err) => {
                console.log(err, "err");
            });

        setDownloadingStatistics(false);
    };

    return (
        <>
            {!loadingStatistics && statistics ? (
                <>
                    <MainWrapper>
                        <Container> 
                        <MainHeaderContainer>
                        <HeaderWrapper><Title>Estadísticas</Title></HeaderWrapper>
                            <HelpContainer>
                                <HelpIcon>
                                    <CustomHelpIcon />
                                </HelpIcon>
                                <HelpTooltip>
                                    <p><strong>Completadas:</strong> La reservación fue satisfactoria.</p>
                                    <p><strong>Canceladas:</strong> La reservación fue cancelada por el usuario.</p>
                                    <p><strong>Rechazadas:</strong> La reservación fue rechazada por un admin.</p>
                                    <p><strong>Expiradas:</strong> La reservación caducó (no hubo respuesta de un admin.).</p>
                                    <p><strong>Tiempo:</strong> Tiempo total de reservaciones (de espacios físicos).</p>
                                </HelpTooltip>
                            </HelpContainer>
                        </MainHeaderContainer>
                    <Divider sx={{ marginBottom: "20px" }} />
                    </Container>
                        <Wrapper>
                            <Box>
                                <InsideBox>
                                    <Header>Tiempo</Header>
                                    {/* <Span>{statistics.total_time.toFixed(0)} minutos</Span> */}
                                    <Span>{statistics && statistics.total_time ? statistics.total_time.toFixed(0) + " horas" : "0 horas"}</Span>
                                    <AccessTimeFilledIcon style={{ fontSize: '7rem', color: theme.color.aegon }} />
                                </InsideBox>

                                <InsideBox>
                                    <Header>Más usado</Header>
                                    <Span>{statistics.most_used_resource}</Span>
                                    <EmojiEventsIcon style={{ fontSize: '7rem', color: theme.color.honey }} />
                                </InsideBox>

                                <InsideBox>
                                    <Header>Menos usado</Header>
                                    <Span>{statistics.least_used_resource}</Span>
                                    <BookmarkRemoveIcon style={{ fontSize: '7rem', color: theme.color.ruby }} />
                                </InsideBox>
                            </Box>

                            <DoughnutChart mainText={["Clientes", "totales"]} labelProps={["Admin.", "Normal"]}
                                dataProps={[statistics.number_admins, statistics.total_users - statistics.number_admins]} />
                        </Wrapper>

                        <Wrapper>
                            <BarChart title="Reservaciones completadas" labelProps={completedLabels} dataProps={completedData}
                                barColor="rgba(44, 166, 232, 1)" />

                            <BarChart title="Reservaciones expiradas" labelProps={uncompletedLabels} dataProps={uncompletedData}
                                barColor="rgba(44, 166, 232, 1)" />
                        </Wrapper>

                        <Wrapper>
                            <DoughnutChart mainText={["Reservaciones", "canceladas"]} labelProps={["Total"]}
                                dataProps={[statistics.cancelled_reservations]} />

                            <DoughnutChart mainText={["Reservaciones", "rechazadas"]} labelProps={["Total"]}
                                dataProps={[statistics.rejected_reservations]} />
                        </Wrapper>

                        <Wrapper>
                            <LineChart title="Usuarios registrados en el tiempo" labelProps={dateLabels} dataProps={dateData} />
                            
                            <InvisibleBox />
                        </Wrapper>

                        <Button
                            type="button"
                            variant="contained"
                            sx={{
                                marginTop: "50px",
                                width: "100%",
                                borderRadius: "15px",
                                fontSize: "16px",
                                backgroundColor: theme.color.navy,
                                color: theme.color.white,
                                textTransform: "none",
                                "&:hover": {
                                backgroundColor: theme.color.space,
                                },
                            }}
                            onClick={dlStatistics}
                            disabled={downloadingStatistics}
                            >
                            Descargar
                            <DownloadIcon />
                        </Button>
                    </MainWrapper>
                </>
            ) :
                <Spinner />
            }
        </>
    );
};

export default AdminStatistics;
